import {get, post,} from "services/BaseClient/Client"
import endPoints from "apps/layout/Header/EndPoints"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";




export const getMenuItems= async (): Promise<DataResponse<any>> => {
    const url = `${endPoints.getMenuItems}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

  export const getSearchSuggestion= async (value:string): Promise<DataResponse<any>> => {
    const url = `${endPoints.getSearchSuggestion}/${value}`;
    const config = headers.content_type.application_json;
    return post<DataResponse<any>>(url, value,config);
  };

  export const getUserLastSearch= async (): Promise<DataResponse<any>> => {
    const url = `${endPoints.getUserLastSearch}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };